import { transport } from '@opengov/app-core/transport';

/**
 * Stories-service GraphQL proxy POST helper. Used by the remaining compose-app
 * effects (publicationViewEffects, setupOnlinePublicationEffects) until those
 * are retired.
 *
 * Lives outside the deleted `publicationListEffects.ts` so it survives that
 * file's removal.
 */
export const postQuery = async (query: string, variables: object): Promise<any> => {
  return transport
    .url(`/api/data/objects/stories/v1/graphql`)
    .json({ query, variables })
    .post()
    .json()
    .then((response) => {
      if (response.data) {
        return response.data;
      } else {
        return Promise.reject(response.errors);
      }
    });
};

/**
 * Abortable variant of `postQuery`. Passing an `AbortController` lets callers
 * cancel an in-flight request (e.g. debounced reads that supersede an earlier
 * one). Rejects with the request's `AbortError` when cancelled.
 */
export const postQueryWithSignal = async (
  query: string,
  variables: object,
  controller: AbortController
): Promise<any> => {
  return transport
    .url(`/api/data/objects/stories/v1/graphql`)
    .signal(controller)
    .json({ query, variables })
    .post()
    .json()
    .then((response) => {
      if (response.data) {
        return response.data;
      } else {
        return Promise.reject(response.errors);
      }
    });
};
